module.exports = {
    blogPostDir: "article", // The name of directory that contains your posts.
    siteTitle: "Integral Service", // Site title.
    siteTitleAlt: "Integral Service votre studio Web", // Alternative site title for SEO.
    siteLogo: "/logos/logo-is-white.png", // Logo used for SEO and manifest.
    siteUrl: "https://www.integral-service.fr", // Domain of your website without pathPrefix.
    pathPrefix: "/", // Prefixes all links. For cases when deployed to example.github.io/gatsby-advanced-starter/.
    siteDescription: "Studio Web Lyonnais pour vos applications sur-mesure", // Website description used for RSS feeds/meta description tag.
    siteRss: "/rss.xml", // Path to the RSS file.
    siteFBAppID: "112572482745004", // FB Application ID for using app insights
    googleAnalyticsID: "UA-46886702-1", // GA tracking ID.
    disqusShortname: "integral-service", // Disqus shortname.
    postDefaultCategoryID: "Tech", // Default category for posts.
    userName: "Integral Service", // Username to display in the author segment.
    userTwitter: "", // Optionally renders "Follow Me" in the UserInfo segment.
    userLocation: "Lyon, France", // User location to display in the author segment.
    userAvatar: "https://api.adorable.io/avatars/150/test.png", // User avatar to display in the author segment.
    userDescription: "Yeah, I like animals better than people sometimes... Especially dogs. Dogs are the best. Every time you come home, they act like they haven't seen you in a year. And the good thing about dogs... is they got different dogs for different people.", // User description to display in the author segment.
    // Links to social profiles/projects you want to display in the author segment/navigation bar.
    userLinks: [{
            label: "GitHub",
            url: "https://github.com/Vagr9K/gatsby-advanced-starter",
            iconClassName: "fa fa-github"
        },
        {
            label: "Twitter",
            url: "https://twitter.com/Vagr9K",
            iconClassName: "fa fa-twitter"
        },
        {
            label: "Email",
            url: "mailto:vagr9k@gmail.com",
            iconClassName: "fa fa-envelope"
        }
    ],
    copyright: "Copyright © 2017. Integral Service" // Copyright string for the footer of the website and RSS feed.
};


// WEBPACK FOOTER //
// ./data/SiteConfig.js